import { computed, reactive, ref } from 'vue'
import { defineStore } from 'pinia'
import type { AudioState } from '../types/audio'

export const useAudioStore = defineStore('app.audio', () => {
  const audios = ref<{ [name: string]: AudioState }>({})

  function createAudioState(name: string, props?: any) {
    if (!audios.value[name]) {
      audios.value[name] = {
        // $audio: new Audio(props?.tracks.length && props.tracks[0].src || ''),
        $audio: new Audio(),
        modeAutoplay: props?.modeAutoplay ?? true,
        modeRepeat: props?.modeRepeat ?? true,
        status: props?.modeAutoplay ? 'playing' : 'paused',
        track: (props?.tracks.length && props.tracks[0].id) ?? 0,
        tracks: props?.tracks ?? [],
      }
      return true
    }
    return false
  }

  function pauseAllAudio() {
    for (var key in audios.value) {
      audios.value[key].status = 'paused'
    }
  }

  function $reset() {
    pauseAllAudio()
  }

  return {
    audios,
    createAudioState,
    pauseAllAudio,
    $reset,
  }
})
